"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToTabsProps({ data, mappers, packages, forms }) {
    return {
        data: (data?.items || []).map((item) => {
            if (typeof item.mainContent === 'object' && item.mainContent !== null) {
                return {
                    title: item?.title,
                    content: mappers.mapRichText({ richText: item.mainContent, mappers, packages, forms }),
                    isVertical: data?.vertical,
                };
            }
        })
    };
}
exports.default = mapToTabsProps;
